import React from 'react';
import {
  Container,
  Box,
  Typography,
  Grid,
  Paper,
  useTheme,
  Button
} from '@mui/material';
import WhyMe from '../components/WhyMe';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PageHeader from '../components/PageHeader';

const WhyMePage = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <>
      <PageHeader
        title={t.over.whyMe.title}
        subtitle={language === 'nl' ? 'Ontdek hoe mijn aanpak jou helpt groeien' : 'Discover how my approach helps you grow'}
      />

      <Container maxWidth="lg" sx={{ pb: { xs: 6, md: 8 } }}>
         <Grid container spacing={{ xs: 4, md: 6 }} alignItems="flex-start">
            <Grid item xs={12} md={5}>
                <Box 
                >
                    <Box
                      component="img" 
                      src="/Hanneke_van_Keulen.png" 
                      alt={language === 'nl' ? 'Hanneke van Keulen' : 'Hanneke van Keulen'} 
                      sx={{ 
                          width: '100%',
                          height: 'auto',
                          display: 'block',
                          borderRadius: '12px',
                          boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
                      }} 
                    />
                </Box>
            </Grid>
            <Grid item xs={12} md={7}>
                <WhyMe />
            </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default WhyMePage; 